import React from 'react';

interface ServiceStatusCardProps {
    carPlate: string;
}

const DeliveryStartedStatusCard: React.FC<ServiceStatusCardProps> = ({ carPlate }) => {
    return (
        <div className="row d-flex flex-column-reverse flex-md-row justify-content-center align-items-center">
            <div className="col-md-6 my-md-5">
                <h1>Orden tomada</h1>
                <h2>Placa: {carPlate}</h2>
                <p>Tu solicitud ha sido recibida. Nuestro equipo está preparando tu vehículo para la entrega.</p>
            </div>
            <div className="col-md-6 my-5 p-1 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#ffffff44", borderRadius: '8px' }}>
                <img src="/assets/service_accepted.svg" alt="Preparando vehículo" />
            </div>
        </div>
    );
};

export default DeliveryStartedStatusCard;
